var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { DialogStateModel } from './dialog.state.model';
import { DialogActions } from './dialog.actions';
import { DialogService } from '../dialog.service';
var DialogState = /** @class */ (function () {
    function DialogState(dialogService) {
        this.dialogService = dialogService;
    }
    /**
     * Selectors
     */
    DialogState.getOpenDialog = function (state) {
        return state.openDialog;
    };
    /**
     * Actions
     */
    // Premium Content
    DialogState.prototype.openPremiumContent = function (context, action) {
        var dialogRef = this.dialogService.openPremiumContentDialog();
        dialogRef.afterClosed()
            .subscribe(function (confirmed) {
            context.dispatch(new DialogActions.ClosePremiumContent(confirmed));
        });
    };
    DialogState.prototype.closePremiumContent = function (context, action) {
        if (action.confirmed) {
            context.dispatch(new DialogActions.OpenUpgrade());
        }
    };
    // Upgrade
    DialogState.prototype.openUpgrade = function (context, action) {
        this.dialogService.openUpgradeDialog();
    };
    __decorate([
        Action(DialogActions.OpenPremiumContent),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DialogActions.OpenPremiumContent]),
        __metadata("design:returntype", void 0)
    ], DialogState.prototype, "openPremiumContent", null);
    __decorate([
        Action(DialogActions.ClosePremiumContent),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DialogActions.ClosePremiumContent]),
        __metadata("design:returntype", void 0)
    ], DialogState.prototype, "closePremiumContent", null);
    __decorate([
        Action(DialogActions.OpenUpgrade),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DialogActions.OpenUpgrade]),
        __metadata("design:returntype", void 0)
    ], DialogState.prototype, "openUpgrade", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [DialogStateModel]),
        __metadata("design:returntype", void 0)
    ], DialogState, "getOpenDialog", null);
    DialogState = __decorate([
        State({
            name: 'dialog',
            defaults: {
                openDialog: null
            }
        }),
        __metadata("design:paramtypes", [DialogService])
    ], DialogState);
    return DialogState;
}());
export { DialogState };
